let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("gd4qs")).then(() => parcelRequire('b60fG'));